exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".BlockAppSideNav .nav-item {\n  margin-bottom: 30px; }\n\n.BlockAppSideNav .nav-link {\n  margin-left: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/blocks/AppSideNav.scss
// module id = 518
// module chunks = 0